export class GridHelper {
  public getRows(items: any[], maxByRow: number): Array<any[]> {
    let rows: Array<any[]> = []

    for (let index = 0; index < this.rowCount(items, maxByRow); index++) {
      let start = index * maxByRow
      let end = start + maxByRow

      rows.push(items.slice(start, end))
    }

    return rows
  }

  private rowCount(items: any[], limit: number) {
    return Math.ceil(items.length / limit)
  }
}

export default new GridHelper()
